(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["az-invite"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Section JavaScript is bundled and may execute before the section markup
    // has been parsed, so wait for the document when that is the case.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    function init() {
    const dialog = document.querySelector('dialog.az-welcome');
    if (!dialog) return;

    // Upgrade the in-flow fallback into a real modal: focus containment,
    // Escape, inert background and the backdrop all come from the platform.
    if (typeof dialog.showModal === 'function') {
      if (dialog.open) dialog.close();
      dialog.showModal();
      // The title should be what gets announced, rather than the close button.
      dialog.setAttribute('tabindex', '-1');
      dialog.focus();
    }

    // Shopify returns to this page with ?customer_posted=true. Left in place, a
    // refresh would re-open the panel over and over. Dropping it afterwards is
    // purely cosmetic — the subscription itself already happened server-side,
    // and nothing here is used to decide whether it did.
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.has('customer_posted')) {
        url.searchParams.delete('customer_posted');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      }
    } catch (e) {
      /* URL unavailable — the panel still works, it just reopens on refresh. */
    }

    const copy = dialog.querySelector('[data-az-copy]');
    const status = dialog.querySelector('[data-az-copy-status]');

    if (copy) {
      const original = copy.textContent.trim();
      const copiedLabel = copy.dataset.copiedLabel || 'Copied';
      let timer;

      copy.addEventListener('click', async function () {
        const code = copy.dataset.azCopy;
        let ok = false;

        try {
          await navigator.clipboard.writeText(code);
          ok = true;
        } catch (e) {
          // Older browsers, and any non-secure context.
          try {
            const scratch = document.createElement('textarea');
            scratch.value = code;
            scratch.setAttribute('readonly', '');
            scratch.style.position = 'fixed';
            scratch.style.opacity = '0';
            dialog.appendChild(scratch);
            scratch.select();
            ok = document.execCommand('copy');
            dialog.removeChild(scratch);
          } catch (e2) {
            ok = false;
          }
        }

        copy.textContent = ok ? copiedLabel : original;
        if (status) status.textContent = ok ? copiedLabel + ': ' + code : 'Press Control or Command C to copy ' + code;

        clearTimeout(timer);
        timer = setTimeout(function () {
          copy.textContent = original;
          if (status) status.textContent = '';
        }, 2600);
      });
    }

    // Send focus somewhere useful once the panel is dismissed.
    dialog.addEventListener('close', function () {
      const field = document.querySelector('.az-invite__input');
      if (field) field.focus({ preventScroll: true });
    });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
